<template>
    <v-alert :type="getAlertType(vigenciaCompetencias)" dense :color="vigenciaCompetencias === '' ? 'blue-grey' : ''">
        {{ getAlertText(vigenciaCompetencias) }}
    </v-alert>
</template>
<script>
    import moment from 'moment'

    export default {
        props: {
            vigenciaCompetencias: {
                type: String,
            },
        },

        methods: {
            getAlertType(fecha_vigencia) {
                if (fecha_vigencia !== '') {
                    return moment(fecha_vigencia, 'MM/DD/YYYY').diff(moment(), 'months', true) > 7 ? 'success' : 'error'
                } else return 'info'
            },

            getAlertText(fecha_vigencia) {
                if (fecha_vigencia !== '') {
                    return 'Competencias básicas: ' + this.getDateText(fecha_vigencia)
                } else return 'Competencias básicas: Fecha no registrada'
            },
        },
    }
</script>
